export const GET_MY_FUNDS_DETAIL = "FUND@GET_MY_FUNDS_DETAIL";
export const GET_MY_FUNDS_DETAIL_INIT = "FUND@GET_MY_FUNDS_DETAIL_INIT";
export const GET_MY_FUNDS_DETAIL_SUCCESS = "FUND@GET_MY_FUNDS_DETAIL_SUCCESS";
export const GET_MY_FUNDS_DETAIL_FAILED = "FUND@GET_MY_FUNDS_DETAIL_FAILED";

export const UPLOAD_TEAR_SHEET = "FUND@UPLOAD_TEAR_SHEET";
export const UPLOAD_TEAR_SHEET_INIT = "FUND@UPLOAD_TEAR_SHEET_INIT";
export const UPLOAD_TEAR_SHEET_SUCCESS = "FUND@UPLOAD_TEAR_SHEET_SUCCESS";
export const UPLOAD_TEAR_SHEET_FAILED = "FUND@UPLOAD_TEAR_SHEET_FAILED";

export const INVESTORS_LIST = "FUND@INVESTORS_LIST";
export const INVESTORS_LIST_INIT = "FUND@INVESTORS_LIST_INIT";
export const INVESTORS_LIST_SUCCESS = "FUND@INVESTORS_LIST_SUCCESS";
export const INVESTORS_LIST_FAILED = "FUND@INVESTORS_LIST_FAILED";

export const UPDATE_MONTHLY_RETURN = "FUND@UPDATE_MONTHLY_RETURN";
export const UPDATE_MONTHLY_RETURN_INIT = "FUND@UPDATE_MONTHLY_RETURN_INIT";
export const UPDATE_MONTHLY_RETURN_SUCCESS =
  "FUND@UPDATE_MONTHLY_RETURN_SUCCESS";
export const UPDATE_MONTHLY_RETURN_FAILED = "FUND@UPDATE_MONTHLY_RETURN_FAILED";

export const SEARCH_PMRESULT = "FUND@SEARCH_PMRESULT";
export const SEARCH_PMRESULT_INIT = "FUND@SEARCH_PMRESULT_INIT";
export const SEARCH_PMRESULT_SUCCESS = "FUND@SEARCH_PMRESULT_SUCCESS";
export const SEARCH_PMRESULT_FAILED = "FUND@SEARCH_PMRESULT_FAILED";

export const SEARCH_RPRESULT = "FUND@SEARCH_RPRESULT";
export const SEARCH_RPRESULT_INIT = "FUND@SEARCH_RPRESULT_INIT";
export const SEARCH_RPRESULT_SUCCESS = "FUND@SEARCH_RPRESULT_SUCCESS";
export const SEARCH_RPRESULT_FAILED = "FUND@SEARCH_RPRESULT_FAILED";

export const SEARCH_REPORTRESULT = "FUND@SEARCH_REPORTRESULT";
export const SEARCH_REPORTRESULT_INIT = "FUND@SEARCH_REPORTRESULT_INIT";
export const SEARCH_REPORTRESULT_SUCCESS = "FUND@SEARCH_REPORTRESULT_SUCCESS";
export const SEARCH_REPORTRESULT_FAILED = "FUND@SEARCH_REPORTRESULT_FAILED";

export const GET_FUND_BIO_USER = "FUND@GET_FUND_BIO_USER";
export const GET_FUND_BIO_USER_INIT = "FUND@GET_FUND_BIO_USER_INIT";
export const GET_FUND_BIO_USER_SUCCESS = "FUND@GET_FUND_BIO_USER_SUCCESS";
export const GET_FUND_BIO_USER_FAILED = "FUND@GET_FUND_BIO_USER_FAILED";